<template>
  <div>
    <PolitiqueConfidentialite />
  </div>
</template>

<script>
import PolitiqueConfidentialite from '@/components/PrivacyDoc.vue'

export default {
  components: { PolitiqueConfidentialite }
}
</script>